import React from "react"
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import Image from "gatsby-image"
import { FaShareSquare, FaGithub } from "react-icons/fa"

import Technology from "../UI/Technology/technology"
import Title from "../UI/Title/title"
import classes from "./projects.module.scss"

const getDescription = (project, language) => {
  if(language === "en" && project.description_en) {
    return project.description_en;
  }
  return project.description;
}

const Projects = props => {
  const { t } = useTranslation()
  const { language } = useI18next()

  return (
    <section>
      <Title type="primary">{props.title}</Title>
      <div className={classes.Center}>
        {props.projects.map((project, index) => {
          const {
            id,
            stack,
            title,
            web_url,
            image,
            github_url,
          } = project

          return (
            <div className={classes.Project} key={id}>
              <Image
                fluid={image.childImageSharp.fluid}
                className={classes.Image}
                alt={`Project ${index + 1}`}
                imgStyle={{ height: "100%" }}
              />
              <div className={classes.Content}>
                <span className={classes.ProjectNumber}>{`${(
                  "0" +
                  (index + 1)
                ).slice(-2)}.`}</span>
                <h3>{title}</h3>
                <p>{getDescription(project, language)}</p>

                <div className={classes.Stack}>
                  {stack.map(item => (
                    <Technology key={item.id}>{item.name}</Technology>
                  ))}
                </div>

                <div className={classes.Links}>
                  <a
                    href={web_url}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.LinkPrimary}
                  >
                    <FaShareSquare /> {t("projectsSection.buttons.visit")}
                  </a>
                  {github_url && (
                    <a
                      href={github_url}
                      target="_blank"
                      rel="noreferrer"
                      className={classes.LinkSecondary}
                    >
                      <FaGithub /> {t("projectsSection.buttons.code")}
                    </a>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Projects
